<template>
  <aside><!---
   <h3 class="mb-2 text-xl font-semibold tracking-tight text-gray-05">대화 히스토리</h3>
  -->
   <div
     class="flex items-center bg-white/70 backdrop-blur-sm border border-white/60 shadow-[0_4px_24px_rgba(0,0,0,0.06)] py-1 rounded-2xl px-[6px]"
     :class="{ 'pl-4': !hasItem.prev, 'pr-4': !hasItem.next }"
   >
    <button
      @click="() => handleCarousel('prev')"
      v-if="hasItem.prev && data.length"
      class="mr-[6px]"
    >
     <img
       :src="next"
       alt="prev" 
       class="rotate-180"
     />
    </button>
    <div
      class="w-full overflow-hidden min-h-[150px] inline-flex items-center"
      ref="carouselContainerRef"
    >
     <ul
       class="flex items-center gap-6 transition-all w-fit"
       :class="{ 'justify-center !w-full min-h-[196px]': !data.length }"
     >
      <template v-if="data.length">
       <li
         v-for="(history, idx) in sortedData"
         ref="carouselItemRef"
         :key="idx"
       >
        <CarouselCard
          v-bind="history"
          :id="history.id"
          @onDelete="handleDelete"
          @onClick="() => handleClick(history.id)"
        />
       </li>
      </template>
      <li
        v-else
        class="text-gray-500"
      >대화 히스토리가 없습니다.</li>
     </ul>
    </div>
    <button
      @click="() => handleCarousel('next')"
      v-if="hasItem.next && data.length"
      class="ml-[6px]"
    >
     <img
       :src="next"
       alt="next"
     />
    </button>
   </div>
  </aside>
 </template>
 
 <script setup>
 import { useRouter } from 'vue-router';
 import { nextTick, ref, watch, computed } from 'vue';
 import next from '@/assets/next.svg'
 import CarouselCard from '@/components/ui/CarouselCard.vue';
 import { useStore } from 'vuex';
 const store = useStore();
 
 const props = defineProps({
  modelValue: {
   type: Array, 
   default: () => ([]),
  }
 })
 
 const data = ref(props.modelValue)
 console.log('Carousel data:', data.value)
 
 const hasItem = ref({ prev: false, next: false })
 const carouselItemRef = ref([])
 const carouselContainerRef = ref(null)
 const currentPosition = ref(0);
 
 /**
  * carousel 총 길이
  */
 function calculateTotalWidth() {
  if (!carouselItemRef.value[0]?.parentNode) return;
  
  const gap = parseInt(getComputedStyle(carouselItemRef.value[0].parentNode).gap) || 0;
  const totalWidth = carouselItemRef.value.reduce(
   (acc, item) => acc + item.clientWidth + gap,
   -gap
  );
  return totalWidth;
 }
 
 /**
  * carousel의 한계 체크 후, 다음 버튼 숨김
  */
 function checkCarouselLimits() {
  if (!carouselItemRef.value[0] || !carouselContainerRef.value) return;
 
  const carouselWidth = carouselContainerRef.value.offsetWidth;
  const totalWidth = calculateTotalWidth();
 
  hasItem.value.prev = currentPosition.value < 0;
  hasItem.value.next = totalWidth > carouselWidth && Math.abs(currentPosition.value) + carouselWidth < totalWidth;
 }

 const sortedData = computed(() => {
  return [...data.value].sort((a, b) => {
    return new Date(b.last_activity) - new Date(a.last_activity)
  })
})
 
 watch(() => props.modelValue, (newValue) => {
  data.value = newValue
  nextTick(() => {
   checkCarouselLimits();
  });
  console.log('Data changed:', newValue)
 }, {immediate: true, deep: true})
 
 /**
  * @param {number} idx
  */
 function handleClose(idx) {
  data.value.splice(idx, 1);
 
  nextTick(() => {
   const totalWidth = calculateTotalWidth();
 
   if (Math.abs(currentPosition.value) >= totalWidth) {
    currentPosition.value = Math.max(0, currentPosition.value - carouselItemRef.value[0]?.clientWidth);
   }
   
   if (!carouselItemRef.value[0]?.parentNode) return
   carouselItemRef.value[0].parentNode.style.transform = `translateX(${currentPosition.value}px)`;
   checkCarouselLimits();
  })
 
 }
 
 /**
  * @param {'next' | 'prev'} direction 
 */
 function handleCarousel(direction) {
  if (!carouselItemRef.value[0] || !carouselContainerRef.value) return;
 
  const moveDistance = carouselItemRef.value[0].clientWidth;
 
  if (direction === 'next') {
   currentPosition.value -= moveDistance;
  } else {
   currentPosition.value += moveDistance;
  }
 
  carouselItemRef.value[0].parentNode.style.transform = `translateX(${currentPosition.value}px)`;
  checkCarouselLimits();
 }

 const router = useRouter()
 function handleClick(id) {
  router.push({ name: 'ChatPub', query: { historyId: id } })
 }

 /**
  * 채팅 세션 삭제 처리
  * @param {string} message - 삭제 결과 메시지
  */
 function handleDelete(message) {
  // 삭제 성공 메시지를 표시하기 위해 부모 컴포넌트로 이벤트 전달
  emit('showMessage', message);
  
  // 캐러셀 위치 재계산
  nextTick(() => {
    const totalWidth = calculateTotalWidth();
    
    if (Math.abs(currentPosition.value) >= totalWidth) {
      currentPosition.value = Math.max(0, currentPosition.value - carouselItemRef.value[0]?.clientWidth);
    }
    
    if (!carouselItemRef.value[0]?.parentNode) return;
    carouselItemRef.value[0].parentNode.style.transform = `translateX(${currentPosition.value}px)`;
    checkCarouselLimits();
  });
 }

 // 이벤트 정의 추가
 const emit = defineEmits(['showMessage']);
 </script>